var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"com-avatar",style:(_vm.avatarStyle),attrs:{"src":_vm.path,"alt":"用户头像"}})}
var staticRenderFns = []

export { render, staticRenderFns }